module.exports = {
  title: 'Wfauz',
  logo: '',
  url: 'https://wafuz.com',
  favicon: '../common/static/favicon/favicon.png',
  cover: '',
  legalName: 'WAFUZ',
  description: 'WAFUZ',
  socialLinks: {
    twitter: '',
    github: '',
    linkedin: '',
    instagram: '',
    youtube: '',
    google: '',
  },
  themeColor: '#62c2c8',
  backgroundColor: '#3f3f3e',
  social: {
    facebook: '',
    twitter: '',
  },
  address: {
    city: '',
    region: '',
    country: '',
    zipCode: '',
  },
  contact: {
    email: '',
    phone: '',
  },
  foundingDate: '2019',
  googleVerification: 'xxx',
};
